// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2UO9v","detailsBorder":"styles_detailsBorder__2YRJu"};